import React from 'react';
import './SubHeading.styles.scss';

export const SubHeading = ({ children }) => (
  <div className="subHeading-wrapper">{children}</div>
);
